import dayjs, {Dayjs} from "dayjs";
import {isNil} from "lodash";

export const getIsValidDate = (date?: Dayjs | null | string, format?: string) => {
    if (isNil(date)) {
        return false;
    }
    return format ? dayjs(date, format, true).isValid() : dayjs(date).isValid();
};
